module.exports = __webpack_public_path__ + "static/img/1111-default.6d40a664.png";